import {AuthActions, AuthActionType} from './auth.types';

export const successGetSession = (session: any): AuthActionType => ({
    type: AuthActions.SUCCESS_GET_SESSION,
    payload: session
});

export const failedGetSession = (): AuthActionType => ({
  type: AuthActions.FAILED_GET_SESSION
});

export const successLogin = (): AuthActionType => ({
  type: AuthActions.SUCCESS_LOGIN
});

export const failedLogin = (message: string): AuthActionType => ({
  type: AuthActions.FAILED_LOGIN,
  payload: message
});

export const successLogout = (): AuthActionType => ({
  type: AuthActions.SUCCESS_LOGOUT
});

export const failedLogout = (): AuthActionType => ({
  type: AuthActions.FAILED_LOGOUT
});

export const successSignUp = (): AuthActionType => ({
  type: AuthActions.SUCCESS_SIGNUP
});

export const failedSignUp = (message: string): AuthActionType => ({
  type: AuthActions.FAILED_SIGNUP,
  payload: message
});

export const successRecaptcha = (): AuthActionType => ({
  type: AuthActions.SUCCESS_RECAPTCHA
});

export const resetRecaptcha = (): AuthActionType => ({
  type: AuthActions.RESET_RECAPTCHA
});

export const sentVerifyEmail = (): AuthActionType => ({
  type: AuthActions.SENT_VERIFY_EMAIL
});

export const failedVerifyEmail = (): AuthActionType => ({
  type: AuthActions.FAILED_VERIFY_EMAIL
});

export const failedVerify2fa = (): AuthActionType => ({
  type: AuthActions.FAILED_VERIFY_2FA
});

export const successVerify2fa = (): AuthActionType => ({
  type: AuthActions.SUCCESS_VERIFY_2FA
});

export const successForgotPassword = (): AuthActionType => ({
  type: AuthActions.SUCCESS_FORGOT_PASSWORD
})

export const failedForgotPassword = (error: string): AuthActionType => ({
  type: AuthActions.FAILED_FORGOT_PASSWORD,
  payload: error
})

export const successDisableResetPassword = (): AuthActionType => ({
  type: AuthActions.SUCCESS_DISABLE_RESET_PASSWORD
})

export const failedDisableResetPassword = (error: string): AuthActionType => ({
  type: AuthActions.FAILED_DISABLE_RESET_PASSWORD,
  payload: error
})

export const successResetPassword = (): AuthActionType => ({
  type: AuthActions.SUCCESS_RESET_PASSWORD
})

export const failedResetPassword = (error: string): AuthActionType => ({
  type: AuthActions.FAILED_RESET_PASSWORD,
  payload: error
})

export const setResetKey = (resetKey: string): AuthActionType => ({
  type: AuthActions.SET_RESET_KEY,
  payload: resetKey,
})

export const clearResetPasswordStatus = (): AuthActionType => ({
  type: AuthActions.CLEAR_RESET_PASSWORD_STATUS,
})

export const setVerifyingEmail = (value: boolean): AuthActionType => ({
  type: AuthActions.SET_VERIFYING_EMAIL,
  payload: value,
})

export const setVerifying2FA = (value: boolean): AuthActionType => ({
  type: AuthActions.SET_VERIFYING_2FA,
  payload: value,
})

export const clearError = (id: number): AuthActionType => ({
  type: AuthActions.CLEAR_ERROR,
  payload: id
})

export const setAllowToken = (token: string | null): AuthActionType => ({
  type: AuthActions.SET_ALLOW_TOKEN,
  payload: token
})

export const setRejectToken = (token: string | null): AuthActionType => ({
  type: AuthActions.SET_REJECT_TOKEN,
  payload: token
})

